import {
  Activity,
  BookOpen,
  Boxes,
  ClipboardCheck,
  Download,
  Gift,
  GitCompare,
  GraduationCap,
  HeartPulse,
  Layers,
  Library,
  ListChecks,
  Microscope,
  Presentation,
  ScanLine,
  ShieldCheck,
  Sparkles,
  Star,
  Stethoscope,
  Syringe,
  Users,
  Wrench,
  type LucideIcon,
} from 'lucide-react'

export interface IncludedFeature {
  label: string
  icon: LucideIcon
  /** Headline features get a larger, highlighted card */
  featured?: boolean
}

export const everythingIncluded: IncludedFeature[] = [
  { label: '6 Professional Visual Training Volumes', icon: Library, featured: true },
  { label: 'Complete 6-IN-1 Training System', icon: Boxes, featured: true },
  { label: 'Ready-to-Teach Lessons', icon: Presentation, featured: true },
  { label: 'Dental Anatomy & Tooth Morphology', icon: BookOpen },
  { label: 'Oral Histology', icon: Microscope },
  { label: 'Clinical Diagnosis', icon: Stethoscope },
  { label: 'Dental Radiology', icon: ScanLine },
  { label: 'Restorative Dentistry', icon: Wrench },
  { label: 'Dental Materials', icon: Layers },
  { label: 'Endodontics & Periodontics', icon: Activity },
  { label: 'Local Anesthesia', icon: Syringe },
  { label: 'Oral Surgery & Patient Management', icon: HeartPulse },
  { label: 'Infection Control & Safety', icon: ShieldCheck },
  { label: 'Simulation Lab Drills', icon: Users },
  { label: '❌/✅ Comparisons', icon: GitCompare },
  { label: 'Competency Rubrics', icon: ClipboardCheck },
  { label: 'Drills & Quick Checks', icon: ListChecks },
  { label: 'Easy to Advanced Variants', icon: Star },
  { label: 'Instructor Resources', icon: GraduationCap },
  { label: '5 Exclusive Bonuses', icon: Gift, featured: true },
  { label: 'Teaching Cues', icon: Sparkles },
  { label: 'Lesson Plans', icon: Activity },
  { label: 'Immediate Digital Access', icon: Download },
]
